export default __webpack_public_path__ + "static/media/Gif_PrisonbreakER.99490c45.gif";